export enum LvfEquipmentAcquisitionMode {
  UNKNOWN = 0,
  PURCHASED = 1,
  RENTED = 2
}
